import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState: FilterState = {
    filter: { priceRange: [], filteredItems: [] },
};

export const filterSlice = createSlice({
    name: 'collectionFilter',
    initialState,
    reducers: {
        setCollectionFilter: (
            state,
            action: PayloadAction<CollectionFilterModel>
        ) => {
            state.filter = { ...state.filter, ...action.payload };
        },
    },
});

export interface FilterState {
    filter: CollectionFilterModel;
}
export const filterActions = filterSlice.actions;

export default filterSlice.reducer;

export interface CollectionFilterModel {
    priceRange: number[];
    filteredItems: any[];
}
